import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { PaymentsService } from '@services/payments/payments.service';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss']
})
export class PaymentSuccessComponent implements OnInit {

  constructor(private paymentsService: PaymentsService, private authenticationService: AuthenticationService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    const sessionid = this.route.snapshot.queryParams['session_id'];

    this.paymentsService.onSuccess(sessionid).subscribe(result => {
      this.authenticationService.sendAuthStateChangeNotification(true);
    })
  }

}
